// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    padding: 0;
    margin: 0;
}

.MAVideoHeading{
    margin: 0 30vw 0 15vw;
    display: flex;
    align-items: center;
}

.MAVideoActivity-image{
    width: 70px;
    margin-right: 20px;
}

.MAVideoActivity-image img{
    width: 100%;
}

.MAVideoActivity-text{
    color: rgb(52, 151, 156);
    font-size: 20px;
}

.MAVideoContainer{
    display: flex;
    justify-content: center;
}

.MAVideoContainer iframe{
    margin: 0 5vw 0 5vw;
    height: 70vh;
    width: 70vw;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Activities/VideoActivity/VideoActivity.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf","sourcesContent":["*{\n    padding: 0;\n    margin: 0;\n}\n\n.MAVideoHeading{\n    margin: 0 30vw 0 15vw;\n    display: flex;\n    align-items: center;\n}\n\n.MAVideoActivity-image{\n    width: 70px;\n    margin-right: 20px;\n}\n\n.MAVideoActivity-image img{\n    width: 100%;\n}\n\n.MAVideoActivity-text{\n    color: rgb(52, 151, 156);\n    font-size: 20px;\n}\n\n.MAVideoContainer{\n    display: flex;\n    justify-content: center;\n}\n\n.MAVideoContainer iframe{\n    margin: 0 5vw 0 5vw;\n    height: 70vh;\n    width: 70vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
